export default __webpack_public_path__ + "static/media/leistungsangebot_button_ausgewÑhlt.0c96b20e.svg";